import { FateCardType } from 'types/fate';

export const AMBITION_RESET : FateCardType = 'AmbitionReset';
export const PURCHASE_STORY: FateCardType = 'PurchaseStory';
export const RESET_STORY: FateCardType = 'ResetStory';
export const DIGITAL: FateCardType = 'Digital';